module.exports = __webpack_public_path__ + "static/media/best_me_5.e0aa4ee7.jpg";